import { create } from "zustand";
import useAppStateStore from "../../../shared/store/AppStateStore";

function getInitialState() {
  return {
    spAddress: {},
    spCancellation: {},
    spLicense: {},
    spOther: {},
    spRegistration: {},
    spUse: {},
    spVehicle: {},
    Payload: {
      Origin: "Web",
      policyNumber: "",
      dateToAction: new Date().toISOString(),
      reasonForCase: "Make a change to my policy",
      Type: "Customer Care",
      Comments: "",
      Changes: {
        Address: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
        LicensingAuthority: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
        Cancellation: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
        Registration: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
        Use: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
        Vehicle: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
        Other: {
          Details: {},
          effectiveFrom: "",
          Requested: false,
        },
      },
    },
  };
}

const useSupportStore = create((set, get) => ({
  ...getInitialState(),
  updateField: (key, value) =>
    set((state) => {
      if (key in state.Payload) {
        return { Payload: { ...state.Payload, [key]: value } };
      }
      return {};
    }),
  updateStepFields: (step, fields) =>
    set((state) => {
      if (step in state) {
        return { [step]: { ...state[step], ...fields } };
      }
      return {};
    }),
  clear: () => set(() => ({ ...getInitialState() })),
}));

export default useSupportStore;
